module.exports = "../images/icons/alert-warning.svg";